import "./RandUser.css"
import { randSmileys, colors } from "../../util/util"

export default function RandUser() {
    return (
        <div className="randUser">
            <div className={`face ${colors.random()}`}>{randSmileys.random()}</div>
        </div>
    )
}